import { createContext } from 'react';

import marketplace from 'cfg/marketplace.json';

export const MartyContext = createContext({
  testId: () => null,
  touchDetected : false,
  preventOnTouchDevice : i => i,
  marketplace,
  router: {}
});
